import { languageSchema } from "./languageSchema.js";
import { makeI18nField } from "../utils/i18nSchemas.js";

export const TAG_TITLE_PATTERN = "^[^;|]*$";

const tagTitleField = {
  type: ["string", "array"],
  pattern: TAG_TITLE_PATTERN,
  items: { type: "string", pattern: TAG_TITLE_PATTERN },
};

export const createTagSchema = {
  type: "object",
  properties: {
    eventId: { type: "number" },
    type: { type: "string", enum: ["people", "session"] },
    subtype: {
      type: "string",
      enum: [
        "categoryOfUser",
        "topicOfInterest",
        "dressCode",
        "sessionType",
        "topic",
      ],
    },
    title: tagTitleField,
    titleI18n: makeI18nField({
      required: true,
      minLength: 1,
      pattern: TAG_TITLE_PATTERN,
    }),
  },
  oneOf: [
    { required: ["type", "subtype", "title"] },
    { required: ["type", "subtype", "titleI18n"] },
  ],
};

export const updateTagSchema = {
  type: "object",
  properties: {
    title: tagTitleField,
    titleI18n: makeI18nField({
      required: true,
      minLength: 1,
      pattern: TAG_TITLE_PATTERN,
    }),
    type: { type: "string", enum: ["people", "session"] },
    subtype: {
      type: "string",
      enum: [
        "categoryOfUser",
        "topicOfInterest",
        "dressCode",
        "sessionType",
        "topic",
      ],
    },
  },
  required: [],
  minProperties: 1,
};

export const deleteTagColorResetSchema = {
  body: {
    type: "object",
    properties: { eventId: { type: "number" } },
    required: ["eventId"],
  },
};

export const getTagByIdSchema = {
  querystring: languageSchema,
  params: {
    type: "object",
    properties: {
      tagId: { type: "number" },
    },
    required: ["tagId"],
  },
};

export const deleteTagByIdSchema = {
  body: {
    type: "object",
    properties: { id: { type: "number" } },
    required: ["id"],
  },
};

export const getPeopleTagsByEventIdSchema = {
  querystring: languageSchema,
  params: {
    type: "object",
    properties: {
      eventId: { type: "number" },
      userId: { type: "number" },
    },
    required: ["eventId", "userId"],
  },
};

export const editInterestTagsSchema = {
  params: {
    type: "object",
    properties: {
      eventId: { type: "number" },
      userId: { type: "number" },
    },
    required: ["eventId", "userId"],
  },
  body: {
    type: "array",
    items: { type: "integer" },
    uniqueItems: true,
  },
};

export const getSessionTagsByEventIdSchema = {
  querystring: languageSchema,
  params: {
    type: "object",
    properties: {
      eventId: { type: "number" },
    },
    required: ["eventId"],
  },
};

export const getSessionTagsSchema = {
  querystring: languageSchema,
  params: {
    type: "object",
    properties: {
      sessionId: { type: "number" },
    },
    required: ["sessionId"],
  },
};

export const web_tagEditSchema = {
  type: "object",
  properties: {
    type: { type: "string", enum: ["people", "session"] },
    subtype: {
      type: "string",
      enum: [
        "categoryOfUser",
        "topicOfInterest",
        "dressCode",
        "sessionType",
        "topic",
      ],
    },
    titleI18n: makeI18nField({
      required: true,
      minLength: 1,
      pattern: TAG_TITLE_PATTERN,
    }),
  },
  required: ["type", "subtype", "titleI18n"],
};

export const web_tagCreateSchema = {
  type: "object",
  properties: {
    type: { type: "string", enum: ["people", "session"] },
    subtype: {
      type: "string",
      enum: [
        "categoryOfUser",
        "topicOfInterest",
        "dressCode",
        "sessionType",
        "topic",
      ],
    },
    title: {
      type: "array",
      items: { type: "string", minLength: 2, pattern: TAG_TITLE_PATTERN },
    },
    titleI18n: makeI18nField({
      required: true,
      minLength: 1,
      pattern: TAG_TITLE_PATTERN,
    }),
    categoryOfUser: {
      type: "array",
      items: { type: "string", minLength: 2, pattern: TAG_TITLE_PATTERN },
    },
  },
  required: ["type", "subtype"],
};
